import { render } from "./GameScene.vue?vue&type=template&id=833e3f6a&scoped=true"
import script from "./GameScene.vue?vue&type=script&lang=js"
export * from "./GameScene.vue?vue&type=script&lang=js"

import "./GameScene.vue?vue&type=style&index=0&id=833e3f6a&scoped=true&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/fw-312-bird-identification-game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833e3f6a"]])

export default __exports__